import React from 'react';
import { Link } from 'gatsby';

const ProductLink = ({ item, children }) => (
  <Link to={`/product/${item.slug ? item.slug.current : ''}`}>
    {children || item.title}
  </Link>
);

export default ProductLink;
